// extracted by mini-css-extract-plugin
export var notificationHost = "_jj-0";